import type { EngineModulationRoute, SequencerConfig, SynthParameters } from "./types";

export const MODULATION_SLOT_COUNT = 15;

export const enum ModulationSlot {
  Lfo1 = 0,
  Lfo2 = 1,
  Envelope = 2,
  AudioRms = 3,
  AudioPeak = 4,
  Sequencer = 5,
  AudioLow = 6,
  AudioMid = 7,
  AudioHigh = 8,
  NotePitch = 9,
  NoteVelocity = 10,
  Noise = 11,
  Expression = 12,
  SampleFrameLow = 13,
  SampleFrameHigh = 14,
}

export type MainToWorkletMessage =
  | { type: "init"; seed: number; sharedBuffer?: SharedArrayBuffer }
  | { type: "parameters"; parameters: Partial<SynthParameters> }
  | { type: "routes"; routes: readonly EngineModulationRoute[] }
  | { type: "note-on"; note: number; velocity: number; owner: string; order: number }
  | { type: "note-off"; note: number; owner: string }
  | { type: "all-notes-off"; immediate?: boolean }
  | { type: "sequencer"; config: SequencerConfig }
  | { type: "transport"; running: boolean; reset?: boolean }
  | { type: "panic" }
  | { type: "resume" };

export type WorkletToMainMessage =
  | {
      type: "modulation";
      sequence: number;
      sampleFrame: number;
      values: [number, number, number, number, number, number, number, number, number, number, number, number, number];
    }
  | { type: "sequencer-note"; note: number; velocity: number; step: number; gateSamples: number }
  | { type: "ready" }
  | { type: "error"; message: string };

export interface SharedModulationLayout {
  sequence: Int32Array;
  values: Float32Array;
}

export function createSharedModulationBuffer(): SharedArrayBuffer {
  // One atomic sequence word, one padding word, then the fixed telemetry slots.
  return new SharedArrayBuffer(8 + Float32Array.BYTES_PER_ELEMENT * MODULATION_SLOT_COUNT);
}

export function viewSharedModulationBuffer(buffer: SharedArrayBuffer): SharedModulationLayout {
  return {
    sequence: new Int32Array(buffer, 0, 1),
    values: new Float32Array(buffer, 8, MODULATION_SLOT_COUNT),
  };
}
